import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Tooltip from '@material-ui/core/Tooltip'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import React, { useState } from 'react'

const HeaderSelectCell = ({
  selectAll,
  effectiveSelectedCount,
  excludedDataIds,
  deselectAllRows,
  toggleSelectAll,
  onToggleCurrentPage
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const excludedCount = excludedDataIds ? excludedDataIds.length : 0
  const selectedRowsCount = effectiveSelectedCount || 0
  const selectedAll = Boolean(selectAll) && excludedCount === 0
  const selectedSome = (Boolean(selectAll) && excludedCount > 0) || (!selectAll && selectedRowsCount > 0)

  const openScopeMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const closeScopeMenu = () => {
    setAnchorEl(null)
  }

  const toggleAllPagesSelection = () => {
    const hasSelectedRows = selectAll || selectedRowsCount > 0

    if (hasSelectedRows) {
      deselectAllRows()
      return
    }

    toggleSelectAll()
  }

  const onSelectAllPages = () => {
    closeScopeMenu()
    toggleSelectAll()
  }

  const onSelectCurrentPage = () => {
    closeScopeMenu()
    onToggleCurrentPage()
  }

  const tooltipTitle = selectedRowsCount > 0 || selectAll
    ? `${selectedRowsCount} charger${selectedRowsCount !== 1 ? 's' : ''} selected`
    : 'Select all'

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Tooltip title={tooltipTitle} placement='top' arrow>
        <Checkbox
          checked={selectedAll}
          indeterminate={selectedSome}
          onChange={toggleAllPagesSelection}
          inputProps={{ 'aria-label': 'primary checkbox' }}
        />
      </Tooltip>
      <IconButton
        size='small'
        onClick={openScopeMenu}
        aria-label='selection scope'
      >
        <KeyboardArrowDownIcon fontSize='small' />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={closeScopeMenu}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuItem onClick={onSelectAllPages}>All pages</MenuItem>
        <MenuItem onClick={onSelectCurrentPage}>Current page</MenuItem>
      </Menu>
    </div>
  )
}

export default HeaderSelectCell
